import { FC, JSX } from 'react';
import { CircularProgress, Box } from '@mui/joy';

type LoaderProps = {
  fullscreen?: boolean;
  size?: 'sm' | 'md' | 'lg';
};

export const Loader: FC<LoaderProps> = ({
  fullscreen = false,
  size = 'sm',
}): JSX.Element => {
  return (
    <Box
      className="Loader-wrapper"
      sx={{
        position: fullscreen ? 'fixed' : 'absolute',
        top: 0,
        left: 0,
        width: fullscreen ? '100vw' : '100%',
        height: fullscreen ? '100vh' : '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
        zIndex: 99999,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        pointerEvents: 'none',
      }}
    >
      <CircularProgress size={size} />
    </Box>
  );
};
